import { render, staticRenderFns } from "./LostItemDetailInfoPopup.vue?vue&type=template&id=647e886a&scoped=true&"
import script from "./LostItemDetailInfoPopup.vue?vue&type=script&lang=js&"
export * from "./LostItemDetailInfoPopup.vue?vue&type=script&lang=js&"
import style0 from "./LostItemDetailInfoPopup.vue?vue&type=style&index=0&id=647e886a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647e886a",
  null
  
)

export default component.exports